import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

import { ReactNode } from "react";

export const authRequestPath = "auth-request-path";

export const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { session } = useAuth();
  const { pathname } = useLocation();
  if (!session) {
    window.localStorage.setItem(authRequestPath, pathname);
    return <Navigate to="/login" />;
  }
  return children;
};
